import axios from "axios";

export const state = {
    districts: [],
};

export const getters = {
    districts: state => state.districts,
};

export const mutations = {
    setdistricts(state, newValue) {
        state.districts = newValue
    },
};

export const actions = {
    fetchDistricts({ commit }) {
        axios.get('/get_districts').then(res => {
            commit('setdistricts', res.data.data);
        })
    },
};
